import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPONSE_LIST_ANOMALY_ACTIVE_REQUEST,
    RESPONSE_LIST_ANOMALY_HISTORY,
    RESPONSE_ANOMALY_REQUEST_CREATED,
    RESPONSE_ANOMALY_REQUEST_DELETED,
    RESPONSE_ANOMALY_REQUEST_UPDATED,
    RESPONSE_ALL_REQUESTS_ACKNOWLEDGED,
    RESPONSE_ANOMALY_REQUEST_ACKNOWLEDGED,
    RESPONSE_ANOMALY_REQUEST_CLEARED,
    RESPONSE_ALL_LIST_ANOMALY_ACTIVE_REQUEST,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import eisenhowerStore from "../eisenhowerStore";
import { eisenhowerActions } from "../eisenhowerSlice";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { AnomalyRequest } from "userful-chronos-app-common-js/dist/models/eisenhower/anomaly/anomaly";

registerMsgHandler(RESPONSE_LIST_ANOMALY_ACTIVE_REQUEST, (payload) => {
    console.debug("receive RESPONSE_LIST_ANOMALY_ACTIVE_REQUEST");
    const data = JSON.parse(payload) as AnomalyRequest[];
    eisenhowerStore.dispatch(eisenhowerActions.setAnomalies(data));
});

registerMsgHandler(RESPONSE_LIST_ANOMALY_HISTORY, (payload) => {
    console.debug("receive RESPONSE_LIST_ANOMALY_HISTORY");
    const data = JSON.parse(payload) as AnomalyRequest[];
    eisenhowerStore.dispatch(eisenhowerActions.setHistory(data));
});

registerMsgHandler(RESPONSE_ANOMALY_REQUEST_CREATED, (payload) => {
    console.debug("receive RESPONSE_ANOMALY_REQUEST_CREATED");
    const data = JSON.parse(payload) as AnomalyRequest;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateAnomaly(data));
});

registerMsgHandler(RESPONSE_ANOMALY_REQUEST_UPDATED, (payload) => {
    console.debug("receive RESPONSE_ANOMALY_REQUEST_UPDATED");
    const data = JSON.parse(payload) as AnomalyRequest;
    if (data.isAcknowledged) eisenhowerStore.dispatch(eisenhowerActions.removeAnomaly(data.id));
    else eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateAnomaly(data));
});

registerMsgHandler(RESPONSE_ANOMALY_REQUEST_DELETED, (payload) => {
    console.debug("receive RESPONSE_ANOMALY_REQUEST_DELETED");
    const data = JSON.parse(payload) as StringID;
    eisenhowerStore.dispatch(eisenhowerActions.removeAnomaly(data));
    eisenhowerStore.dispatch(eisenhowerActions.requestRemoveHistory(data));
});

registerMsgHandler(RESPONSE_ANOMALY_REQUEST_ACKNOWLEDGED, (payload) => {
    console.debug("receive RESPONSE_ANOMALY_REQUEST_ACKNOWLEDGED");
    const data = JSON.parse(payload) as AnomalyRequest;
    // eisenhowerStore.dispatch(eisenhowerActions.removeAnomaly(data.id));
});

registerMsgHandler(RESPONSE_ALL_REQUESTS_ACKNOWLEDGED, (payload) => {
    console.debug("receive RESPONSE_ALL_REQUESTS_ACKNOWLEDGED");
    eisenhowerStore.dispatch(eisenhowerActions.setAnomalies([]));
});

registerMsgHandler(RESPONSE_ANOMALY_REQUEST_CLEARED, (payload) => {
    console.debug("receive RESPONSE_ANOMALY_REQUEST_CLEARED");
    eisenhowerStore.dispatch(eisenhowerActions.setHistory([]));
});

registerMsgHandler(RESPONSE_ALL_LIST_ANOMALY_ACTIVE_REQUEST, (payload) => {
    console.debug("receive RESPONSE_ALL_LIST_ANOMALY_ACTIVE_REQUEST");
    const data = JSON.parse(payload) as AnomalyRequest[];
    eisenhowerStore.dispatch(eisenhowerActions.setAnomalies(data));
});
